import React, { useRef, useEffect, useState, useContext } from 'react';
import { DataContext } from 'contexts/DataContext';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import EditableGrid from 'components/EditableGrid/EditableGrid';
import Typography from '@mui/material/Typography';
import Add from '@mui/icons-material/Add';
import ModalTitle from 'components/ModalTitle/ModalTitle';
import People from '@mui/icons-material/People';
import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { get, update, destroy, getColumns } from './users_api'

interface DetailProps {
  row: any;
  master?: any;
}
function Users(props:DetailProps) {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const addButtonRef = useRef(null);
  const [columns, setColumns] = useState([] as GridColDef[]);
  useEffect(() => {
    if(dataContext.loading) return;
    getColumns(dataContext.language).then((response) => {
      setColumns(response);
    });
  }, [dataContext.loading, dataContext.language]);

  return (
    <>
    <ModalTitle title={
      <>
        <People />
        <Typography variant="pageTitle" component="h1" gutterBottom>
        {props.master.name}
        {' > '} 
        {props.row.name}
        {' > '} 
        {t('Users')}
        </Typography>
      </>
     } 
     actions={[
      {
        label: t('Add user'),
        icon:<Add />,
        action: () => {
          let addbutton = addButtonRef.current as any;
          addbutton.click();
        }
      }
    ]}
    />
    <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      padding: '30px',
      backgroundColor: (theme) => theme.palette.background.default,
    }}
  >      
      <EditableGrid addButtonRef={addButtonRef} hideAddButton={true} master={props.row} columns={columns} get={get} update={update} delete={destroy} 
      name='userGrid'
      reloadParentOnEditStop={true}
      labels={{
        "actions": t('Actions'),
        "add": {
          "button": t("Add user")
        }
      }}/>
    </Box>
    </>
  );
}

export default Users;
